import { slackTrelloDomain } from '@trello/config';
import { fetchWithTimeout } from './fetchWithTimeout';
import { Analytics } from '@trello/atlassian-analytics';

interface SlackUserProfile {
  email: string;
  display_name: string;
  display_name_normalized: string;
  real_name_normalized: string;
  real_name: string;
  image_32: string;
  image_48: string;
}

export interface SlackUserResults {
  id: string;
  name: string;
  profile: SlackUserProfile;
}

export interface SlackUsers {
  isCacheValid: boolean;
  results: SlackUserResults[];
}

export const getSlackUsers = async (
  searchQuery: string,
  idBoard: string,
  cookie: string,
): Promise<SlackUsers> => {
  const queryParams = new URLSearchParams({
    q: searchQuery,
    boardId: idBoard,
  });
  const res = await fetchWithTimeout(
    `${slackTrelloDomain}/members/search?${queryParams}`,
    cookie,
    {
      timeout: 15000,
    },
  );
  if (res?.ok) {
    Analytics.sendTrackEvent({
      action: 'succeeded',
      actionSubject: 'fetchSlackUsers',
      source: 'inviteToBoardInlineDialog',
      attributes: {
        growthInitiative: 'inviteFromGoogleAndMicrosoft',
      },
    });
    return res?.json();
  } else {
    throw res;
  }
};
